import React from "react";
const AlertTxnPwd = (props) => {
    const { msg, className = "", setRequestTxnPwd, updateTxnPwd } = props;
    return (
        <div className="alert" >
            <div
                className={`confirmation ${className}`}
                onClick={(e) => e.stopPropagation()}
                style={{ background: '#FFF', paddingBottom: '20px', width: '440px' }}
            >
                <div
                    className="alert--content success"
                    style={{ width: "100%", padding: "20px" }}
                >
                    {msg}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 20px' }}>
                    <div
                        style=
                        {{
                            width: '100px',
                            padding: '12px 16px',
                            border: '1px solid #FF7100',
                            color: '#FF7100',
                            marginRight: '12px',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                        onClick={() => setRequestTxnPwd(false)}>{'CANCEL'}</div>
                    <div className="go-to-home"
                        style={{
                            width: 'calc(100% - 100px)',
                            padding: '12px 16px', textAlign: 'left',
                            cursor: 'pointer',
                        }}
                        onClick={() => updateTxnPwd()}>
                        {'REQUEST TRANSACTION PASSWORD'}</div>
                </div>
            </div>
        </div>
    );
};

export default AlertTxnPwd;